import { forwardRef } from "react";
import type { ForwardedRef } from "react";
import { useTranslation } from "react-i18next";
import lodash from "lodash";
import classNames from "classnames";

type InputBooleanProps = {
    edit?: boolean;
    value?: boolean;
    trueValue?: any;
    falseValue?: any;
    inputLabel?: string;
    trueLabel?: string;
    falseLabel?: string;
    readOnly?: boolean;
    onChange?: (value: boolean) => void;
    align?: "start" | "left" | "center" | "right" | "end";
    //
    show?: any;
};

export const InputBoolean = forwardRef((props: InputBooleanProps, ref: ForwardedRef<HTMLInputElement>) => {
    const {
        edit = true,
        value,
        trueValue = true,
        falseValue = false,
        onChange,
        readOnly,
        inputLabel,
        trueLabel,
        falseLabel,
        align,
        show,
        ...rest
    } = props;

    const { t } = useTranslation();

    const _handleChange = (event: any) => {
        if (onChange) {
            if (event.target.checked) {
                onChange(trueValue);
            } else {
                onChange(falseValue);
            }
        }
    };
    const checked = lodash.isEqual(value, trueValue);

    return edit && !readOnly ? (
        <label
            className={classNames("flex items-center h-7 space-x-1 mr-3", {
                "justify-center w-full": align === "center",
                "justify-start w-full": align === "left",
                "justify-end w-full": align === "right",
            })}
        >
            <input {...rest} ref={ref} type="checkbox" onChange={_handleChange} checked={checked} />
            {!!inputLabel && !trueLabel && !falseLabel && <div>{t(inputLabel)}</div>}
            {checked && !!trueLabel && <div>{t(trueLabel)}</div>}
            {!checked && !!falseLabel && <div>{t(falseLabel)}</div>}
        </label>
    ) : (
        <span>{checked ? trueValue : falseValue}</span>
    );
});
